// lib/emails/mailLink.ts
// #554: Links in angezeigten Mails. Manche Absender (z. B. E.ON) schreiben „www.eon.de/…“ ohne
// https:// — der Browser löste das relativ zur App auf und landete auf dem Dashboard.

const DATEI_ENDUNGEN = new Set(['html', 'htm', 'php', 'aspx', 'asp', 'jsp', 'pdf', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'txt']);

/** Link-Ziel für die Mailanzeige: fehlendes Schema ergänzen; App-relative Ziele verwerfen (null). */
export function normalisiereMailLink(href: string | null | undefined): string | null {
  const h = (href ?? '').trim();
  if (!h) return null;
  if (h.startsWith('#')) return h;
  if (/^(https?:|mailto:|tel:)/i.test(h)) return h;
  if (h.startsWith('//')) return `https:${h}`;
  if (/^www\./i.test(h)) return `https://${h}`;
  const host = /^([a-z0-9-]+(?:\.[a-z0-9-]+)*\.([a-z]{2,}))(?::\d+)?(?:[/?#]|$)/i.exec(h);
  // „datei.html“ ist kein Host — typische Dateiendungen als „Top-Level-Domain“ ausschließen.
  if (host && !DATEI_ENDUNGEN.has(host[2].toLowerCase())) return `https://${h}`;
  return null;
}
